import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationComponent } from 'src/app/modules/shared/confirmation/confirmation.component';
import { FilesService } from 'src/app/services/shared/files/files.service';
import { NotificationService } from 'src/app/services/shared/notification/notification.service';
import { storage_url } from '../../functions/shared-functions';

@Component({
  selector: 'tm-profile-picture',
  templateUrl: './tm-profile-pictute.component.html',
  styleUrls: ['./tm-profile-pictute.component.scss'],
  providers: [FilesService]
})
export class TmProfilePictuteComponent implements OnInit {

  @Input() form_group;
  @Input() field;
  @Input() disabled;

  storage_url = storage_url;
  constructor(
    private notification_svc: NotificationService,
    private file_srv: FilesService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
  }

  profileCaptureStarted;
  setupDevices(obj) {
    if (!this.profileCaptureStarted) {
      this.notification_svc.success('Please wait while video device is being initializing', 'Close', 5000)
      let out_obj = {
        screenCapture: '',
        error: 'You have no output video device',
        camCapture: '',
        id: 0,
        status: 1
      };
      let width = 400;
      let height = 0;
      let streaming = false;
      let camera = document.getElementById('camera');
      let video: any = document.getElementById('video');
      let startbutton = document.getElementById('startbutton');
      let cancelButton = document.getElementById('cancelButton');
      // camera.appendChild(video)
      // camera.appendChild(cancelButton)
      // camera.appendChild(startbutton)
      video.autoplay = true;

      let canvas = document.createElement('canvas');
      if (obj.isCamShot) {
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
          this.profileCaptureStarted = true;
          try {
            navigator.mediaDevices.getUserMedia({ video: true }).then(stream => {
              if (stream) {
                video.srcObject = stream;
                video.play();
                video.addEventListener('canplay', ev => {
                  camera.classList.add('d-flex')
                  if (!streaming) {
                    height = video.videoHeight / (video.videoWidth / width);
                    if (isNaN(height)) {
                      height = width / (4 / 3);
                    }
                    video.setAttribute('width', width.toString());
                    video.setAttribute('height', height.toString());
                    canvas.setAttribute('width', width.toString());
                    canvas.setAttribute('height', height.toString());
                    streaming = true;
                    // var context = canvas.getContext('2d');
                    // canvas.width = width;
                    // canvas.height = height;
                    // context.drawImage(video, 0, 0, width, height);
                    // let img = canvas.toDataURL('image/png');
                    // out_obj.camCapture = img;
                    // stream.getTracks().forEach(function (track) {
                    //   track.stop();
                    // });
                    // video.remove();
                    // canvas.remove();
                    // this.getCDNPath(out_obj)

                  }
                }, false);
                startbutton.addEventListener('click', ev => {
                  var context = canvas.getContext('2d');
                  canvas.width = width;
                  canvas.height = height;
                  context.drawImage(video, 0, 0, width, height);
                  let img = canvas.toDataURL('image/png');
                  out_obj.camCapture = img;

                  stream.getTracks().forEach(function (track) {
                    track.stop();
                  });
                  canvas.remove();
                  camera.classList.remove('d-flex');
                  this.profileCaptureStarted = false;
                  console.log(out_obj);
                  this.form_group.get(this.field.fieldID).setValue(out_obj.camCapture)
                  // startbutton.remove();
                  // this.getCDNPath(out_obj)
                })
                cancelButton.addEventListener('click', ev => {
                  stream.getTracks().forEach(function (track) {
                    track.stop();
                  });
                  canvas.remove();
                  camera.classList.remove('d-flex');
                  this.profileCaptureStarted = false;
                  // startbutton.remove();
                })
                out_obj.error = null;
              } else {
                out_obj.error = 'You have no output video device';
              }
            }).catch(err => {
              this.profileCaptureStarted = false;
              this.notification_svc.error('RESUME.please_enable_camera_permission_to_capture_photo', 'Close', 8000)
            });
          } catch (e) {
            out_obj.error = e;
          }
        }
      }
    }
    else { }
  }


  fileInputChanged(event) {

    let reader = new FileReader();
    let file = event.target.files[0];
    // if (file) {
    //   this.result = Object.assign([], file || []);
    //   this.returnFiles.emit({ files: this.result, source: this.flag })
    // }
    // this.profilePhoto = this.dataURItoBlob(file, undefined, undefined);

    this.file_srv.convertFilesToBase64(event.target.files).subscribe(res => {

      // this.profilePhoto = res

    })
    if (event.target.files && event.target.files[0]) {
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.form_group.get(this.field.fieldID).setValue(reader.result);

        // this.registrationForm.patchValue({
        //   file: reader.result
        // });
        // this.editFile = false;
        // this.removeUpload = true;
      }

      // this.change_detector.markForCheck();
    }

    // this.result = [];
    // this.parsingInProgress = true;
    // this.hideUploadButton = true;
    // this.imageChangedEvent = files;
  }

  removeUploadedFile() {
    this.dialog.open(ConfirmationComponent, {
      width: "480px",
      height: "auto",
      panelClass: "icr-dialog",
      data: {
        title: "ERROR.confirmation",
        message: "CONFIRMATION.are_you_sure_to_delete",
        positive_button: "BTN.yes",
        negative_button: "BTN.no"
      },
    }).afterClosed().subscribe((res) => {
      if (res) {
        // this.uploadedImageUrl = ''
        // this.editFile = true;
        // this.removeUpload = false;
        this.form_group.get(this.field.fieldID).setValue('')
      }
    });



    // this.el.nativeElement.files = []
    // this.el.nativeElement.remove();

    // this.registrationForm.patchValue({
    //   file: [null]
    // });
  }


}
